import styled from 'styled-components';

export const StyledForm = styled.form`
   display: flex;
   flex-direction: column;
   gap: 24px;
`;

StyledForm.displayName = 'StyledForm';

export const ThreeColumnsGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(3, 1fr);
   gap: 24px;
`;

ThreeColumnsGrid.displayName = 'ThreeColumnsGrid';

export const FourColumnsGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: 24px;
`;

FourColumnsGrid.displayName = 'FourColumnsGrid';
